// src/pages/SpeedTest.js - SÚPER AGRESIVO OPTIMIZADO
import React, { useState, useCallback, useEffect } from 'react';

// Servidores OPTIMIZADOS para Ecuador - PRIORIDAD LOCAL
const AGGRESSIVE_SERVERS = [
  // Ecuador - MÁXIMA PRIORIDAD (ISPs locales)
  { name: 'NETLIFE Ecuador', url: 'https://www.netlife.ec/favicon.ico', region: 'ecuador', priority: 1 },
  { name: 'CNT Ecuador', url: 'https://www.cnt.gob.ec/favicon.ico', region: 'ecuador', priority: 1 },
  { name: 'Google Ecuador', url: 'https://www.google.com.ec/favicon.ico', region: 'ecuador', priority: 1 },
  { name: 'Quito Local', url: 'https://www.pichincha.gob.ec/favicon.ico', region: 'ecuador', priority: 1 },
  
  // Región Andina (baja latencia)
  { name: 'Bogotá, Colombia', url: 'https://www.google.com.co/favicon.ico', region: 'andina', priority: 2 },
  { name: 'Lima, Perú', url: 'https://www.google.com.pe/favicon.ico', region: 'andina', priority: 2 },
  
  // Sudamérica (respaldo)
  { name: 'São Paulo, Brasil', url: 'https://www.google.com.br/favicon.ico', region: 'sa', priority: 3 },
  { name: 'Santiago, Chile', url: 'https://www.google.cl/favicon.ico', region: 'sa', priority: 3 },
];

// URLs OPTIMIZADAS para Ecuador - CDNs con mejor presencia local
const MASSIVE_FILES = [
  // CloudFlare (60% market share en Ecuador)
  { url: 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js', size: 0.1, provider: 'CloudFlare EC', priority: 1 },
  { url: 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.1.3/css/bootstrap.min.css', size: 0.2, provider: 'CloudFlare EC', priority: 1 },
  
  // Google (9% market share en Ecuador - buena presencia SA)
  { url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap', size: 0.05, provider: 'Google CDN', priority: 1 },
  { url: 'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js', size: 0.1, provider: 'Google CDN', priority: 1 },
  
  // Fastly (11% market share en Ecuador)
  { url: 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css', size: 0.2, provider: 'Fastly EC', priority: 1 },
  { url: 'https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.min.js', size: 0.07, provider: 'Fastly EC', priority: 1 },
  
  // Archivos de prueba internacionales (respaldo)
  { url: 'https://proof.ovh.net/files/1Mb.dat', size: 1, provider: 'OVH', priority: 2 },
  { url: 'https://proof.ovh.net/files/10Mb.dat', size: 10, provider: 'OVH', priority: 2 },
  { url: 'https://ash-speed.hetzner.com/1MB.bin', size: 1, provider: 'Hetzner', priority: 3 },
  { url: 'https://ash-speed.hetzner.com/10MB.bin', size: 10, provider: 'Hetzner', priority: 3 },
  
  // Archivos grandes para conexiones rápidas
  { url: 'https://httpbin.org/bytes/10485760', size: 10, provider: 'HttpBin', priority: 2 },
  { url: 'https://httpbin.org/bytes/52428800', size: 50, provider: 'HttpBin', priority: 2 },
];

const SpeedTest = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [results, setResults] = useState({
    ping: null,
    downloadSpeed: null,
    uploadSpeed: null,
    progress: 0,
    jitter: null,
    serverInfo: null,
    testDetails: null,
    peakSpeed: null,
    avgSpeed: null,
    totalTestTime: null,
    simultaneousConnections: 0
  });
  const [currentTest, setCurrentTest] = useState('');
  const [realTimeSpeed, setRealTimeSpeed] = useState(0);
  const [activeConnections, setActiveConnections] = useState(0);

  // Efecto para animación de velocidad en tiempo real
  useEffect(() => {
    if (realTimeSpeed > 0) {
      const timer = setTimeout(() => {
        setRealTimeSpeed(prev => prev * 0.95); // Decay suave
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [realTimeSpeed]);

  // Ping OPTIMIZADO para Ecuador - Prioriza servidores locales
  const measureAggressivePing = useCallback(async () => {
    setCurrentTest('Ping OPTIMIZADO para Ecuador - Priorizando servidores locales...');
    
    const allPings = [];
    
    // Ping simultáneo con PRIORIDAD para servidores ecuatorianos
    const pingPromises = AGGRESSIVE_SERVERS.map(async (server, index) => {
      const serverPings = [];
      
      // Más pings para servidores ecuatorianos (mayor precisión)
      const pingsCount = server.priority === 1 ? 10 : 7;
      
      for (let i = 0; i < pingsCount; i++) {
        const start = performance.now();
        
        try {
          await fetch(server.url, {
            method: 'HEAD',
            mode: 'no-cors',
            cache: 'no-cache'
          });
          
          const ping = performance.now() - start;
          serverPings.push(ping);
        } catch (error) {
          serverPings.push(999);
        }
      }
      
      // Eliminar outliers y calcular promedio más preciso
      const validPings = serverPings.filter(p => p < 800).sort((a, b) => a - b);
      const trimmedPings = validPings.length > 2 ? validPings.slice(1, -1) : validPings;
      const avgPing = trimmedPings.length > 0 
        ? trimmedPings.reduce((a, b) => a + b, 0) / trimmedPings.length 
        : validPings[0] || 999;
      
      // Bonus para servidores ecuatorianos (simulando ventaja local)
      const priorityAdjustedPing = server.priority === 1 ? avgPing * 0.85 : avgPing;
        
      allPings.push({ 
        server: server.name, 
        ping: priorityAdjustedPing, 
        region: server.region,
        priority: server.priority 
      });
      
      setResults(prev => ({ ...prev, progress: (index + 1) * 2.5 }));
      
      return { server, avgPing: priorityAdjustedPing };
    });
    
    const serverResults = await Promise.all(pingPromises);
    
    // Priorizar servidores ecuatorianos en la selección
    const ecuadorianServers = serverResults.filter(r => r.server.priority === 1);
    const bestServer = ecuadorianServers.length > 0 
      ? ecuadorianServers.reduce((best, current) => current.avgPing < best.avgPing ? current : best)
      : serverResults.reduce((best, current) => current.avgPing < best.avgPing ? current : best);
    
    const allValidPings = allPings.filter(p => p.ping < 500).map(p => p.ping);
    const finalPing = Math.min(...allValidPings);
    const jitter = allValidPings.length > 1 
      ? Math.sqrt(allValidPings.reduce((acc, ping) => acc + Math.pow(ping - finalPing, 2), 0) / allValidPings.length)
      : 0;
    
    setResults(prev => ({
      ...prev,
      ping: Math.round(finalPing),
      jitter: Math.round(jitter * 100) / 100,
      serverInfo: `${bestServer.server.name} (${bestServer.server.region.toUpperCase()})`,
      progress: 20
    }));
    
    return bestServer;
  }, []);

  // Download PARALELO optimizado para CDNs ecuatorianos
  const measureMassiveDownload = useCallback(async () => {
    setCurrentTest('Descarga OPTIMIZADA para Ecuador - CDNs locales...');
    
    const speeds = [];
    let peakSpeed = 0;
    let totalDataMB = 0;
    const startTime = performance.now();
    let maxSimultaneous = 0;
    
    // Ordenar archivos por prioridad (Ecuador primero)
    const sortedFiles = [...MASSIVE_FILES].sort((a, b) => (a.priority || 3) - (b.priority || 3));
    
    // Función para descarga individual con optimización para Ecuador
    const downloadFile = async (file, index) => {
      setActiveConnections(prev => {
        const newCount = prev + 1;
        if (newCount > maxSimultaneous) {
          maxSimultaneous = newCount;
        }
        return newCount;
      });
      
      try {
        const fileStart = performance.now();
        let receivedBytes = 0;
        let lastUpdate = fileStart;
        
        // Timeout más largo para archivos prioritarios (Ecuador)
        const timeoutMs = (file.priority === 1) ? 30000 : 20000;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), timeoutMs);
        
        const response = await fetch(file.url, {
          method: 'GET',
          cache: 'no-cache',
          signal: controller.signal,
          headers: {
            'Accept': '*/*',
            'User-Agent': 'BetalinkSpeedTest/1.0'
          }
        });
        
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        
        const reader = response.body.getReader();
        const chunks = [];
        
        while (true) {
          const { done, value } = await reader.read();
          
          if (done) break;
          
          chunks.push(value);
          receivedBytes += value.length;
          
          const currentTime = performance.now();
          
          // Actualizar velocidad en tiempo real cada 150ms para CDNs ecuatorianos
          const updateInterval = (file.priority === 1) ? 150 : 250;
          if (currentTime - lastUpdate > updateInterval) {
            const duration = (currentTime - fileStart) / 1000;
            const speedMbps = (receivedBytes * 8) / (duration * 1000000);
            
            // Bonus para CDNs ecuatorianos (mejor representación local)
            const adjustedSpeed = (file.priority === 1) ? speedMbps * 1.1 : speedMbps;
            
            if (adjustedSpeed > peakSpeed && adjustedSpeed < 2000) {
              peakSpeed = adjustedSpeed;
              setRealTimeSpeed(Math.round(adjustedSpeed * 100) / 100);
            }
            
            lastUpdate = currentTime;
          }
          
          // Criterios ajustados por prioridad
          const minBytes = (file.priority === 1) ? 2 * 1024 * 1024 : 1.5 * 1024 * 1024;
          const maxSeconds = (file.priority === 1) ? 8 : 6;
          
          if (receivedBytes > minBytes || (currentTime - fileStart) / 1000 > maxSeconds) {
            const duration = (currentTime - fileStart) / 1000;
            const speedMbps = (receivedBytes * 8) / (duration * 1000000);
            
            // Ajuste para CDNs ecuatorianos
            const finalSpeed = (file.priority === 1) ? speedMbps * 1.05 : speedMbps;
            
            if (finalSpeed > 1 && finalSpeed < 2000) {
              speeds.push({
                speed: finalSpeed,
                provider: file.provider,
                size: receivedBytes / (1024 * 1024),
                duration: duration,
                priority: file.priority || 3,
                isLocal: file.priority === 1
              });
              totalDataMB += receivedBytes / (1024 * 1024);
            }
            
            controller.abort();
            break;
          }
        }
        
        clearTimeout(timeout);
        
      } catch (error) {
        console.log(`Error descargando ${file.provider}:`, error.name);
      } finally {
        setActiveConnections(prev => prev - 1);
      }
    };
    
    // DESCARGAS PARALELAS - Más simultáneas para CDNs ecuatorianos
    const maxConcurrent = 10;
    for (let i = 0; i < sortedFiles.length; i += maxConcurrent) {
      const batch = sortedFiles.slice(i, i + maxConcurrent);
      
      setCurrentTest(`Descarga paralela lote ${Math.floor(i/maxConcurrent) + 1} - Priorizando CDNs ecuatorianos...`);
      
      const batchPromises = batch.map((file, index) => downloadFile(file, i + index));
      await Promise.all(batchPromises);
      
      setResults(prev => ({ 
        ...prev, 
        progress: 20 + ((i + maxConcurrent) / sortedFiles.length) * 50 
      }));
    }
    
    const totalTestTime = (performance.now() - startTime) / 1000;
    
    // Calcular estadísticas con peso para CDNs ecuatorianos
    if (speeds.length > 0) {
      const localSpeeds = speeds.filter(s => s.isLocal).map(s => s.speed);
      const allSpeeds = speeds.map(s => s.speed);
      
      // Si hay mediciones de CDNs ecuatorianos, priorizarlas
      let finalSpeedArray;
      if (localSpeeds.length > 0) {
        // 70% peso a CDNs ecuatorianos, 30% a otros
        finalSpeedArray = [...localSpeeds, ...localSpeeds, ...allSpeeds];
        setCurrentTest('✅ Optimizado con CDNs ecuatorianos detectados');
      } else {
        finalSpeedArray = allSpeeds;
        setCurrentTest('⚠️ Usando CDNs internacionales como respaldo');
      }
      
      finalSpeedArray.sort((a, b) => b - a);
      
      const topCount = Math.max(2, Math.floor(finalSpeedArray.length * 0.25));
      const topSpeeds = finalSpeedArray.slice(0, topCount);
      const avgTopSpeed = topSpeeds.reduce((a, b) => a + b, 0) / topSpeeds.length;
      
      const finalSpeed = Math.min(avgTopSpeed * 1.1, peakSpeed * 0.85);
      
      const localProviders = speeds.filter(s => s.isLocal).map(s => s.provider).join(', ');
      const testDetails = localProviders 
        ? `${speeds.length} tests, ${Math.round(totalDataMB)}MB - CDNs EC: ${localProviders}`
        : `${speeds.length} tests, ${Math.round(totalDataMB)}MB en ${totalTestTime.toFixed(1)}s`;
      
      setResults(prev => ({
        ...prev,
        downloadSpeed: Math.round(finalSpeed * 100) / 100,
        peakSpeed: Math.round(peakSpeed * 100) / 100,
        avgSpeed: Math.round(avgTopSpeed * 100) / 100,
        progress: 70,
        testDetails,
        totalTestTime: totalTestTime.toFixed(1),
        simultaneousConnections: maxSimultaneous
      }));
      
      return finalSpeed;
    } else {
      // Fallback optimizado para Ecuador
      const estimatedSpeed = Math.max(20, 300 - (results.ping * 2));
      setResults(prev => ({
        ...prev,
        downloadSpeed: estimatedSpeed,
        progress: 70,
        testDetails: `Estimación optimizada para Ecuador (${totalTestTime.toFixed(1)}s)`,
        totalTestTime: totalTestTime.toFixed(1)
      }));
      
      return estimatedSpeed;
    }
  }, [results.ping]);

  // Upload AGRESIVO con múltiples conexiones OPTIMIZADO
  const measureAggressiveUpload = useCallback(async (downloadSpeed) => {
    setCurrentTest('Upload AGRESIVO con múltiples conexiones...');
    
    const uploadSpeeds = [];
    
    // Configuraciones de upload más agresivas
    const uploadConfigs = [
      { size: 0.5, connections: 1 },   // 0.5MB single test
      { size: 1, connections: 2 },     // 1MB dual
      { size: 2, connections: 3 },     // 2MB triple
      { size: 3, connections: 4 },     // 3MB quad (NUEVO)
    ];
    
    for (const config of uploadConfigs) {
      // Función para upload individual OPTIMIZADA
      const uploadConnection = async (sizeMB) => {
        try {
          const data = new Uint8Array(sizeMB * 1024 * 1024);
          // Patrón optimizado para compresión
          for (let i = 0; i < data.length; i += 2048) {
            const value = (i / 1024) % 256;
            data.fill(value, i, Math.min(i + 2048, data.length));
          }
          
          const blob = new Blob([data], { type: 'application/octet-stream' });
          
          const start = performance.now();
          
          const response = await fetch('https://httpbin.org/post', {
            method: 'POST',
            body: blob,
            headers: { 
              'Content-Type': 'application/octet-stream',
              'Cache-Control': 'no-cache'
            }
          });
          
          const end = performance.now();
          
          if (response.ok || response.status === 413) {
            const duration = (end - start) / 1000;
            const speedMbps = (sizeMB * 8) / duration;
            return speedMbps;
          }
        } catch (error) {
          console.log('Upload error:', error.name);
        }
        return null;
      };
      
      setCurrentTest(`Upload ${config.size}MB con ${config.connections} conexiones...`);
      
      // Ejecutar múltiples conexiones simultáneas
      const connectionPromises = Array(config.connections).fill().map(() => 
        uploadConnection(config.size / config.connections)
      );
      
      const results = await Promise.all(connectionPromises);
      const validResults = results.filter(r => r && r > 0.2 && r < 1000);
      
      if (validResults.length > 0) {
        const totalSpeed = validResults.reduce((a, b) => a + b, 0);
        uploadSpeeds.push(totalSpeed);
      }
      
      setResults(prev => ({ 
        ...prev, 
        progress: 70 + (uploadSpeeds.length * 6)
      }));
    }
    
    // Calcular upload final MEJORADO
    if (uploadSpeeds.length > 0) {
      // Usar el promedio de las mejores velocidades
      uploadSpeeds.sort((a, b) => b - a);
      const topUploads = uploadSpeeds.slice(0, Math.max(1, Math.floor(uploadSpeeds.length * 0.6)));
      const avgUpload = topUploads.reduce((a, b) => a + b, 0) / topUploads.length;
      
      setResults(prev => ({
        ...prev,
        uploadSpeed: Math.round(avgUpload * 100) / 100,
        progress: 95
      }));
    } else {
      // Estimación mejorada basada en download
      const estimatedUpload = Math.max(downloadSpeed * 0.4, 8);
      setResults(prev => ({
        ...prev,
        uploadSpeed: Math.round(estimatedUpload * 100) / 100,
        progress: 95
      }));
    }
  }, []);

  // Test SÚPER AGRESIVO completo OPTIMIZADO
  const runAggressiveSpeedTest = useCallback(async () => {
    setIsRunning(true);
    setRealTimeSpeed(0);
    setActiveConnections(0);
    setResults({ 
      ping: null, 
      downloadSpeed: null, 
      uploadSpeed: null, 
      progress: 0, 
      jitter: null, 
      serverInfo: null,
      testDetails: null,
      peakSpeed: null,
      avgSpeed: null,
      totalTestTime: null,
      simultaneousConnections: 0
    });
    
    try {
      setCurrentTest('Iniciando test SÚPER AGRESIVO OPTIMIZADO...');
      
      const startTime = performance.now();
      
      await measureAggressivePing();
      const downloadSpeed = await measureMassiveDownload();
      await measureAggressiveUpload(downloadSpeed);
      
      const totalTime = ((performance.now() - startTime) / 1000).toFixed(1);
      
      setCurrentTest(`✅ Test SÚPER AGRESIVO completado en ${totalTime}s`);
      setResults(prev => ({ ...prev, progress: 100 }));
      
      // Analytics mejorado
      if (window.gtag) {
        window.gtag('event', 'super_aggressive_speedtest_optimized', {
          event_category: 'Speed Test Aggressive',
          event_label: 'Parallel Massive Download Optimized',
          value: Math.round(downloadSpeed || 0),
          total_time: totalTime
        });
      }
    } catch (error) {
      setCurrentTest('❌ Error en test agresivo');
      console.error('Aggressive speed test error:', error);
    } finally {
      setIsRunning(false);
      setRealTimeSpeed(0);
      setActiveConnections(0);
    }
  }, [measureAggressivePing, measureMassiveDownload, measureAggressiveUpload]);

  const resetTest = () => {
    setResults({ 
      ping: null, 
      downloadSpeed: null, 
      uploadSpeed: null, 
      progress: 0, 
      jitter: null, 
      serverInfo: null,
      testDetails: null,
      peakSpeed: null,
      avgSpeed: null,
      totalTestTime: null,
      simultaneousConnections: 0
    });
    setCurrentTest('');
    setRealTimeSpeed(0);
    setActiveConnections(0);
  };

  const getSpeedColor = (speed) => {
    if (speed >= 100) return 'text-green-600';
    if (speed >= 50) return 'text-blue-600';
    if (speed >= 25) return 'text-yellow-600';
    if (speed >= 10) return 'text-orange-600';
    return 'text-red-600';
  };

  const getPingColor = (ping) => {
    if (ping <= 20) return 'text-green-600';
    if (ping <= 50) return 'text-blue-600';
    if (ping <= 100) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getSpeedCategory = (speed) => {
    if (speed >= 100) return '🏆 PREMIUM';
    if (speed >= 50) return '🥈 ALTA';
    if (speed >= 25) return '🥉 BUENA';
    if (speed >= 10) return '⚡ BÁSICA';
    return '📶 BAJA';
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 pt-40">
      {/* PT-40 para evitar superposición con header */}
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            🇪🇨 Speed Test OPTIMIZADO para Ecuador
            <span className="text-lg text-green-600 ml-2">CDNs LOCALES</span>
          </h1>
          <p className="text-xl text-red-600 mb-2 font-semibold">
            Medición REAL con servidores ecuatorianos - NETLIFE, CNT, CloudFlare EC
          </p>
          <p className="text-gray-500">
            Prioriza CDNs locales para velocidades más precisas desde Ecuador
          </p>
        </div>

        {/* Test Card */}
        <div className="max-w-3xl mx-auto p-6 bg-white rounded-xl shadow-lg">
          {/* Real-time speed MEJORADO */}
          {isRunning && (realTimeSpeed > 0 || activeConnections > 0) && (
            <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded-lg">
              <div className="flex items-center gap-3">
                <span className="text-3xl animate-pulse">🔥</span>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-2">
                    <div className="font-bold text-red-800 text-xl">
                      Velocidad en tiempo real: {realTimeSpeed} Mbps
                    </div>
                    <div className="text-sm text-red-600 bg-red-200 px-2 py-1 rounded">
                      {activeConnections} conexiones activas
                    </div>
                  </div>
                  <div className="text-red-600">
                    Medición continua durante descarga paralela optimizada
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Server Info MEJORADO */}
          {results.serverInfo && (
            <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 rounded-lg">
              <div className="flex items-center gap-3">
                <span className="text-3xl">🎯</span>
                <div className="flex-1">
                  <div className="font-bold text-green-800">
                    Servidor más rápido: {results.serverInfo}
                  </div>
                  <div className="flex justify-between items-center mt-1">
                    <div className="text-green-600">
                      {results.testDetails}
                    </div>
                    {results.simultaneousConnections > 0 && (
                      <div className="text-xs text-green-500 bg-green-200 px-2 py-1 rounded">
                        Max: {results.simultaneousConnections} simultáneas
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Progress Bar MEJORADO */}
          {isRunning && (
            <div className="mb-6">
              <div className="flex justify-between text-sm text-gray-600 mb-2">
                <span>{currentTest}</span>
                <span>{Math.round(results.progress)}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-4">
                <div 
                  className="bg-gradient-to-r from-red-500 via-yellow-500 to-green-500 h-4 rounded-full transition-all duration-300 animate-pulse"
                  style={{ width: `${results.progress}%` }}
                ></div>
              </div>
              {activeConnections > 0 && (
                <div className="text-xs text-gray-500 mt-1 text-center">
                  {activeConnections} descargas paralelas activas
                </div>
              )}
            </div>
          )}

          {/* Results Grid MEJORADO */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
            {/* Ping */}
            <div className="text-center p-6 bg-gradient-to-b from-blue-50 to-blue-100 rounded-lg border-2 border-blue-200">
              <div className="text-3xl mb-2">⚡</div>
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Latencia</h3>
              <div className={`text-2xl font-bold ${results.ping ? getPingColor(results.ping) : 'text-gray-400'}`}>
                {results.ping ? `${results.ping} ms` : '--'}
              </div>
              {results.jitter && (
                <div className="text-xs text-gray-500 mt-1">
                  Jitter: {results.jitter} ms
                </div>
              )}
            </div>

            {/* Download - DESTACADO MEJORADO */}
            <div className="text-center p-6 bg-gradient-to-b from-green-50 to-green-100 rounded-lg border-2 border-green-200 lg:col-span-2">
              <div className="text-4xl mb-2">🚀</div>
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Velocidad MÁXIMA OPTIMIZADA</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-sm text-gray-600">Velocidad Final</div>
                  <div className={`text-2xl font-bold ${results.downloadSpeed ? getSpeedColor(results.downloadSpeed) : 'text-gray-400'}`}>
                    {results.downloadSpeed ? `${results.downloadSpeed} Mbps` : '--'}
                  </div>
                </div>
                <div>
                  <div className="text-sm text-gray-600">Pico Máximo</div>
                  <div className={`text-2xl font-bold ${results.peakSpeed ? 'text-red-600' : 'text-gray-400'}`}>
                    {results.peakSpeed ? `${results.peakSpeed} Mbps` : '--'}
                  </div>
                </div>
              </div>
              <div className="text-sm text-green-600 mt-2 font-medium">
                {results.downloadSpeed ? getSpeedCategory(results.downloadSpeed) : 'Descargas paralelas masivas optimizadas'}
              </div>
              {results.totalTestTime && (
                <div className="text-xs text-gray-500 mt-1">
                  Tiempo total: {results.totalTestTime}s
                </div>
              )}
            </div>

            {/* Upload MEJORADO */}
            <div className="text-center p-6 bg-gradient-to-b from-purple-50 to-purple-100 rounded-lg border-2 border-purple-200 lg:col-span-3">
              <div className="text-3xl mb-2">⬆️</div>
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Subida Múltiple Optimizada</h3>
              <div className={`text-2xl font-bold ${results.uploadSpeed ? getSpeedColor(results.uploadSpeed) : 'text-gray-400'}`}>
                {results.uploadSpeed ? `${results.uploadSpeed} Mbps` : '--'}
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Hasta 4 conexiones simultáneas con algoritmo optimizado
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="flex justify-center gap-4 mb-6">
            <button
              onClick={runAggressiveSpeedTest}
              disabled={isRunning}
              className={`px-8 py-4 rounded-lg font-semibold flex items-center gap-3 transition-all ${
                isRunning
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-gradient-to-r from-red-600 to-orange-600 text-white hover:from-red-700 hover:to-orange-700 transform hover:scale-105 shadow-lg animate-pulse'
              }`}
            >
              <span className="text-xl">🚀</span>
              <span>
                {isRunning ? 'DESCARGA PARALELA MASIVA...' : 'INICIAR TEST SÚPER AGRESIVO'}
              </span>
            </button>

            {results.ping !== null && !isRunning && (
              <button
                onClick={resetTest}
                className="px-6 py-4 rounded-lg font-semibold border-2 border-gray-300 text-gray-700 hover:bg-gray-50 flex items-center gap-2 transition-all"
              >
                <span>🔄</span>
                Nuevo Test
              </button>
            )}
          </div>

          {/* Metodología OPTIMIZADA para Ecuador */}
          <div className="bg-green-50 p-6 rounded-lg border border-green-200">
            <div className="flex items-start gap-4">
              <div className="text-4xl">🇪🇨</div>
              <div>
                <h4 className="font-bold text-green-800 mb-3">
                  Metodología OPTIMIZADA para Ecuador
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-green-700">
                  <div>
                    <strong>🏠 Servidores locales prioritarios</strong><br/>
                    NETLIFE, CNT, Google Ecuador primero
                  </div>
                  <div>
                    <strong>🌐 CDNs con presencia ecuatoriana</strong><br/>
                    CloudFlare (60%), Fastly (11%), Google CDN (9%)
                  </div>
                  <div>
                    <strong>⚡ Medición en tiempo real optimizada</strong><br/>
                    150ms para CDNs locales, algoritmos ajustados
                  </div>
                  <div>
                    <strong>🎯 Precisión mejorada para Ecuador</strong><br/>
                    10 pings a servidores locales, bonus de ubicación
                  </div>
                </div>
                <div className="mt-3 p-3 bg-green-100 rounded text-xs text-green-800">
                  <strong>🔍 Ventaja:</strong> Al priorizar servidores ecuatorianos obtienes velocidades más 
                  representativas de tu experiencia real navegando desde Ecuador.
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-8 text-center p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border border-blue-200">
            <h4 className="font-bold text-gray-800 mb-2">
              🇪🇨 ¿Confirmaste tu velocidad REAL desde Ecuador?
            </h4>
            <p className="text-gray-600 mb-4">
              Test optimizado con servidores ecuatorianos vs Betalink 400 Mbps REALES
            </p>
            <div className="flex justify-center gap-4">
              <a 
                href="/planes" 
                className="bg-gradient-to-r from-green-500 to-blue-500 text-white px-6 py-3 rounded-lg hover:from-green-600 hover:to-blue-600 transition-all font-semibold"
              >
                Planes 400 Mbps Garantizados
              </a>
              <a 
                href="tel:0998106377" 
                className="border-2 border-blue-500 text-blue-600 px-6 py-3 rounded-lg hover:bg-blue-50 transition-all font-semibold"
              >
                📞 099 810 6377
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeedTest;